import { Grid, Typography, useTheme } from '@mui/material'

import FullScreenModal from '../../components/full-screen-modal'
import exampleImg from '../../images/leak-freeze-activation/placement-suggestions/probe-placement/example.svg'
import useIsMobile from '../../utils/hooks/useIsMobile'

import useStyles from './index.styles'

const ProbePlacementModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const theme = useTheme()
  const classes = useStyles
  const isMobile = useIsMobile()

  return (
    <FullScreenModal open={isOpen} onClose={onClose} title="Additional Placement Tips" showCloseIcon={true} confirmLabel="Got it" onConfirm={onClose}>
      <Grid container={true} sx={classes.probeOuterContainer(isMobile)}>
        <Grid container={true} sx={classes.probeSectionColumn}>
          <Typography variant="body2" sx={[classes.probeSubtitle, classes.probePlacementModalSubtitle(theme)]}>
            If using the optional probe:
          </Typography>
          <Typography variant="h6" sx={classes.probeBodyText}>
            Plug the probe into the Aux port and place the probe under appliances.
          </Typography>
        </Grid>

        <Grid container={true} sx={classes.probeSectionColumn}>
          <Typography variant="body2" sx={[classes.probeSubtitle, classes.probePlacementModalSubtitle(theme)]}>
            For basements or below-grade areas:
          </Typography>
          <Typography variant="h6" sx={classes.probeBodyText}>
            Mount the sensor to a wall or near a window using the adhesive strip, then place probe on the floor.
          </Typography>
        </Grid>

        <Grid container={true} sx={classes.probeSectionColumn}>
          <img src={exampleImg} alt="Examples of probe plug in and placement under appliances and on the floor in a basement" />
        </Grid>
      </Grid>
    </FullScreenModal>
  )
}

export default ProbePlacementModal
